import TTLink, { type LinkOptions } from '@tiptap/extension-link';
import { Plugin } from '@tiptap/pm/state';

export const Link = TTLink.extend<LinkOptions>({
  addAttributes() {
    return {
      ...this.parent?.()!,
      'data-script-api-name': {
        default: null,
      },
      clickable: {
        default: false,
        renderHTML: (attributes: Record<string, any>) => {
          if (attributes.clickable) {
            return { 'data-clickable': '' };
          }

          return {};
        },
        parseHTML: (element: HTMLElement) => {
          return element.getAttribute('data-clickable') !== null;
        },
      },
    };
  },

  addProseMirrorPlugins() {
    const plugins = (this as any).parent?.() || [];

    return [
      ...plugins,
      new Plugin({
        props: {
          handleClick(_view, _pos, event) {
            if (!(event.target instanceof HTMLAnchorElement)) {
              return false;
            }

            const { target } = event;

            if ('clickable' in target.dataset) {
              const href = target.getAttribute('href');

              if (href) {
                const anchor = document.createElement('a');
                const targetAttribute = target.getAttribute('target');
                anchor.href = href;
                anchor.rel = 'noopener';

                if (targetAttribute) {
                  anchor.target = targetAttribute;
                }

                anchor.click();
                return true;
              }
            }

            return false;
          },
        },
      }),
    ];
  },
});
